import { fetchCalculatedSurchargeMargin } from 'actions/OfferActions'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import moment from 'moment'
import { useEffect, useMemo } from 'react'

interface Params {
  duration: number
  checkIn?: string
  roomRateId?: string
}

function useSurchargeMargin(params: Params) {
  const { checkIn, duration, roomRateId } = params
  const appDispatch = useAppDispatch()

  const surchargeMargins = useAppSelector(state => state.offer.surchargeMargins)

  const {
    surchargeMarginKey,
    toBeCalculatedSurchargeMarginItem,
  } = useMemo(() => {
    if (!checkIn || !roomRateId) {
      return {
        surchargeMarginKey: '',
        toBeCalculatedSurchargeMarginItem: undefined,
      }
    }
    const checkOut = moment(checkIn).add(duration, 'days').format(ISO_DATE_FORMAT)
    const toBeCalculatedSurchargeMarginItem: App.ToBeCalculatedSurchargeMarginItem = {
      startDate: checkIn,
      endDate: checkOut,
    }

    return {
      surchargeMarginKey: createSurchargeMarginKey(roomRateId, checkIn, checkOut),
      toBeCalculatedSurchargeMarginItem,
    }
  }, [checkIn, duration, roomRateId])

  useEffect(() => {
    if (roomRateId && toBeCalculatedSurchargeMarginItem) {
      appDispatch(fetchCalculatedSurchargeMargin(
        roomRateId, toBeCalculatedSurchargeMarginItem, surchargeMarginKey,
      ))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surchargeMarginKey])

  const surchargeMargin = surchargeMargins?.[surchargeMarginKey]

  return {
    surchargeMargin,
  }
}

function createSurchargeMarginKey(ratePlanId: string, startDate: string, endDate: string) {
  return `${ratePlanId}_${startDate}_${endDate}`
}

export default useSurchargeMargin
